import axios from 'axios';
import React, { useEffect, useState } from 'react';
import PlusIcon from 'mdi-react/PlusIcon';
import WalletIcon from 'mdi-react/WalletIcon';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Row } from 'reactstrap';
import { getToken } from '../../../services/auth';
import { brMoneyMask } from '../../../shared/utils/utils';
import { ValueModal } from '../../../shared/components/ValueModal';
import { useModal } from '../../../providers/ModalContext';

const BalanceBadge = () => {
  const { owner } = localStorage.getItem('client')
    ? JSON.parse(localStorage.getItem('client'))
    : '';
  const [balance, setBalance] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { openModal } = useModal();

  useEffect(() => {
    const handleTopRequest = () => {
      const url = `${process.env.REACT_APP_WAS_KEY}/wallet/balance`;

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            'x-api-key': owner
          }
        })
        .then((res) => {
          setBalance(res.data.balance);
        });
    };

    handleTopRequest();

    const intervalId = setInterval(handleTopRequest, 5000);
    return () => clearInterval(intervalId);
  }, [owner]);

  // const gotToRecharge = () => {
  //   // history.push('/paymentInformation');
  //   setIsModalOpen(true);
  // };

  return (
    <>
      <ValueModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <Row>
        <Col xl={12} className='p-0'>
          <div className="balance-badge d-flex align-items-center mt-2">
            <div className="wallet-icon d-none d-md-flex" aria-hidden="true">
              <WalletIcon />
            </div>
            <div className="balance-content">
              <span className="balance-label">Saldo</span>
              <span className="balance-amount">R$ {brMoneyMask(balance)}</span>
            </div>
            <button
              className="add-button"
              onClick={openModal}
              type="button"
              aria-label="Recarregar saldo"
              title="Recarregar saldo"
            >
              <PlusIcon aria-hidden="true" />
            </button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BalanceBadge;
